export default __webpack_public_path__ + "static/media/ConduitITC-BoldItalic.871a5b04.ttf";